import {getClimateRiskTranslationKey} from "@reva/shared/climate-risk";

export function getTranslationForClimateRiskIndex(
    translation: (key: string) => string,
    index_category: number | null,
): string {
    const key = getClimateRiskTranslationKey(index_category);
    return key ? translation(`climaterisk.${key}`) : "-";
}
